// extracted by mini-css-extract-plugin
export var background = "_4g-0";
export var buttonPrimary = "_4g-1";
export var container = "_4g-2";
export var containerTopLayerApi = "_4g-3";
export var feature = "_4g-6";
export var featureBody = "_4g-7";
export var featureIcon = "_4g-8";
export var featureSummary = "_4g-a";
export var featureTitle = "_4g-9";
export var modal = "_4g-g";
export var modalAction = "_4g-f";
export var modalCloseButton = "_4g-e";
export var modalFeatures = "_4g-5";
export var modalFooter = "_4g-b";
export var modalImageLogo = "_4g-c";
export var modalLogo = "_4g-d";
export var redoModal = "_4g-4";